import { Time } from "@angular/common";
import * as internal from "assert";

export class Aluno {
  Id: string;
  Nome: string;
  Telefone: string;
}

export class Produto {
  Id: string;
  Nome: string;
  Preco: number;
  PrecoPremium: number;
  Imagem: string;
}

export class Cart {
  idLoja: number;
  arrProdutos: CartItem[];
  cartUF: string;
  cartCidade: string;
}
export class CartItem {
  idProduto: number;
  nomeProduto: string;
  prodPreco: number;
  prodPrecoPremium: number;
  fotoProduto: string;
  idLoja: number;
  qtdProduto: number;
}

export class Local {
  categoria: string;
  cidade: string;
  descricao: string;
  email: string;
  endereco: string;
  id: number;
  linkmaps: string;
  logotipo: string;
  nome: string;
  telefone: string;
  uf: string;
  whatsapp: string;
}
export class ShopProd {
  Id: number;
  categoriaurl: string;
  descritivo: string;
  disponivel: boolean;
  foto: string = "";
  idloja: number;
  nome: string = "";
  precoN: number;
  precoV: number;
}

export class Conquista {
  Arquivo: string;
  Colocacao: string;
  Comentario: string;
  CompeticaoParceira: boolean;
  CompeticaoTag: string;
  ConquistaVerificada: boolean;
  DataRegistro: string;
  Id: number;
  IdAluno: number;
  LinkFonte: string;
  Modalidade: string;
  Prova: string;
}

export class Graduacao {
  Id: number;
  Ano: number;
  Curso: string;
  Foto: string;
  Instituicao: string;
  Nivel: string;
}

export class Configuracoes {
  AceitaSeguidores: boolean;
  DietaPadrao: number;
  ExibirAltura: boolean;
  ExibirCidadeUF: boolean;
  ExibirPeso: boolean;
  Id: number;
  IdAluno: number;
  TreinoPadrao: number;
  ViewMode: string;
  NotificacoesChat: boolean;
}

export class FieldsCartao {
  CardHolderName: string;
  CardNumber: string;
  EndDate: string;
  CCV: string;
}

export class BaseNotificacao {
  Id: number;
  Titulo: string;
  Tipo: string;
  //Parametro: string;
  Separador: string;
  Data: Date;
  Hora: string;
  Visualizado: boolean;
  DataF: string;
  Foto: string;
  IdPublicacao?: number;
  NickReagiu?: string;
  QTipo?: string;
  QAct?: string;
  ImagemPub?: string;
  Following?: boolean;
}

export class FeedStruct {
  Id: number;
  Nome: string;
  Descricao: string;
  NomeFoto: string;
  dt: string;
  DifDias: number;
  HoraRegistro: any;
  FotoPerfil: string;
}

export class BasePlanos {
  Id: number;
  Idaluno: number;
  NomePlano: string;
  DataCriado: string;
  DataInicio: string;
  DataRetorno: string;
  DataTermino: string;
  Enviado: boolean;
  Nome: string;
  FotoPerfil: string;
}

export class BaseAvaliacao {
  Id: number;
  IdAluno: number;
  Titulo: string;
  DataAvaliacao: string;
  Enviada: boolean;
  Nome: string;
  FotoPerfil: string;
}

export interface BasicoPaciente {
  nome: string;
  id: number;
  cidade: string;
  data: Date;
  dataf: string;
}
